import React from 'react';
import { formatLimitsUsd } from './ledgerUtils';
import { useUtcDailyLimitReset } from './useUtcDailyLimitReset';
const DAILY_LIMIT_TITLE = 'Daily payout limit';
const DailyLimitHeader = ({ windowLabel, resetLabel, compact = false, titleClassName }) => (React.createElement("div", { className: "flex items-start justify-between gap-3" },
    React.createElement("p", { className: titleClassName }, DAILY_LIMIT_TITLE),
    React.createElement("div", { className: `shrink-0 space-y-0.5 text-right leading-snug text-gray-500 ${compact ? 'text-[11px]' : 'text-xs'}` },
        React.createElement("p", null, windowLabel),
        React.createElement("p", { className: "tabular-nums" }, resetLabel))));
export const PortalWithdrawalLimitsPanel = ({ limits, loading, amountUsd = 0, limitUsageUsd, variant = 'page', }) => {
    const { windowLabel, resetLabel } = useUtcDailyLimitReset();
    if (loading) {
        return (React.createElement("p", { className: "text-xs text-gray-500" }, variant === 'modal' ? 'Loading limits…' : 'Loading payout limits…'));
    }
    if (!limits)
        return null;
    const maxTx = limits.maxWithdrawalPerTransaction;
    const maxDay = limits.maxWithdrawalPerDay;
    const used = limits.withdrawnTodayUsd;
    const remaining = limits.remainingTodayUsd;
    const pct = maxDay > 0 ? Math.min(100, (used / maxDay) * 100) : 0;
    const barClass = pct >= 100 ? 'bg-red-500' : pct >= 80 ? 'bg-amber-500' : 'bg-emerald-500';
    const dailyUsageUsd = limitUsageUsd != null && limitUsageUsd > 0 ? limitUsageUsd : amountUsd;
    const exceedsTx = amountUsd > 0 && amountUsd > maxTx + 1e-9;
    const exceedsDay = dailyUsageUsd > 0 && dailyUsageUsd > remaining + 1e-9;
    if (variant === 'summary') {
        return (React.createElement("div", { className: "flex h-full flex-col" },
            React.createElement(DailyLimitHeader, { windowLabel: windowLabel, resetLabel: resetLabel, compact: true, titleClassName: "text-xs font-medium uppercase tracking-wide text-gray-500" }),
            React.createElement("p", { className: "mt-2 text-lg font-semibold tabular-nums text-gray-900" },
                formatLimitsUsd(used),
                " used of ",
                formatLimitsUsd(maxDay)),
            React.createElement("div", { className: "mt-3 h-2 w-full overflow-hidden rounded-full bg-gray-100", "aria-hidden": true },
                React.createElement("div", { className: `h-full rounded-full transition-all ${barClass}`, style: { width: `${pct}%` } })),
            React.createElement("p", { className: "mt-3 text-sm text-gray-600" },
                "Max ",
                formatLimitsUsd(maxTx),
                " per request"),
            limits.dailyLimitReached ? (React.createElement("p", { className: "mt-2 text-xs font-medium text-red-700" },
                "Daily limit reached. ",
                resetLabel,
                ".")) : null,
            exceedsTx ? (React.createElement("p", { className: "mt-2 text-xs font-medium text-red-700" },
                "Amount exceeds ",
                formatLimitsUsd(maxTx),
                " per request.")) : null,
            !exceedsTx && exceedsDay ? (React.createElement("p", { className: "mt-2 text-xs font-medium text-red-700" },
                "Amount exceeds remaining for this period (",
                formatLimitsUsd(remaining),
                ").")) : null));
    }
    const boxClass = variant === 'modal'
        ? 'rounded-lg border border-amber-100 bg-amber-50/40 p-3 text-sm text-gray-800'
        : 'rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-gray-700';
    return (React.createElement("div", { className: boxClass },
        React.createElement(DailyLimitHeader, { windowLabel: windowLabel, resetLabel: resetLabel, titleClassName: "text-xs font-semibold uppercase tracking-wide text-gray-500" }),
        React.createElement("ul", { className: "mt-2 space-y-1 text-sm" },
            React.createElement("li", null,
                "Up to ",
                formatLimitsUsd(maxTx),
                " per request"),
            React.createElement("li", null,
                "Up to ",
                formatLimitsUsd(maxDay),
                " total per UTC day \u2014 ",
                formatLimitsUsd(used),
                " used,",
                ' ',
                formatLimitsUsd(remaining),
                " left")),
        React.createElement("div", { className: "mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200", "aria-hidden": true },
            React.createElement("div", { className: `h-full rounded-full transition-all ${barClass}`, style: { width: `${pct}%` } })),
        limits.dailyLimitReached ? (React.createElement("p", { className: "mt-2 text-xs font-medium text-red-700" },
            "Daily limit reached. ",
            resetLabel,
            ".")) : null,
        exceedsTx ? (React.createElement("p", { className: "mt-2 text-xs font-medium text-red-700" },
            "Amount exceeds ",
            formatLimitsUsd(maxTx),
            " limit per request.")) : null,
        !exceedsTx && exceedsDay ? (React.createElement("p", { className: "mt-2 text-xs font-medium text-red-700" },
            "Amount exceeds remaining limit for this period (",
            formatLimitsUsd(remaining),
            ").")) : null));
};
export default PortalWithdrawalLimitsPanel;
